<template>
  <button
    :data-testid="dataTestId"
    :data-dd-action-name="`status-button-${btnStatus || label}`"
    class="status-button d-flex layout-row align-items-center i-text-button-2 i-pl-6 i-pr-6 i-pt-4 i-pb-4"
    :class="{
      selected: active,
      approve: btnStatus === options.APPROVE,
      reject: btnStatus === options.REJECT,
    }"
    @click="onBtnClick(btnStatus)"
    @mouseenter="hovering = true"
    @mouseleave="hovering = ''"
  >
    <i-icon
      v-if="icon"
      class="icon"
      :symbol="icon"
      :size="16"
      :class="
        active
          ? activeClass
          : hovering
            ? 'i-text-neutral-90'
            : 'i-text-neutral-80'
      "
    ></i-icon>
    <span class="label d-flex flex-row i-text-neutral-120">{{ label }}</span>
    <i-icon
      v-if="rightIcon"
      class="right-icon"
      :symbol="rightIcon"
      :size="16"
      :class="
        active
          ? activeClass
          : hovering
            ? 'i-text-neutral-80'
            : 'i-text-neutral-70'
      "
    ></i-icon>
  </button>
</template>

<script>
import { iIcon } from '@inscribe/signal';
import { StatusButtonOptions } from '@/constants/statusButtonOptions';

export default {
  components: { iIcon },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    activeClass: {
      type: String,
      default: 'i-text-success-90',
    },
    dataTestId: {
      type: String,
      default: 'btn-with-icon',
    },
    icon: {
      type: String,
      default: null,
    },
    rightIcon: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    btnStatus: {
      type: String,
      default: '',
    },
    onBtnClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      hovering: false,
      options: StatusButtonOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.status-button {
  gap: 8px;
  height: 36px;
  line-height: 20px;
  border-radius: 10px;
  background: $light-neutral-default;
  border: 1px solid $light-neutral-70;
  transition: 150ms ease-out;

  &.disabled {
    cursor: not-allowed;
    background: var(--surface-neutral-subtle);
    border: 1px solid var(--border-neutral-subtle);

    .label {
      color: var(--text-neutral-subtle);
    }

    .icon {
      color: var(--text-neutral-subtle);
    }
  }

  &:hover:not(.disabled) {
    border: 1px solid $light-neutral-90;
  }

  &.selected.reject {
    background: $light-error-30;
    border: 1px solid $light-error-80;
  }

  &.selected.approve {
    background: $light-success-30;
    border: 1px solid $light-success-80;
  }

  .label {
    flex: 1;
    font-weight: 500;
  }
}
</style>
